/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersRoutingModule
 * Purpose		: Routing module for Customers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomersListComponent } from './CustomersList.component';
import { CustomersAddComponent }  from './CustomersAdd.component';
import { CustomersEditComponent } from './CustomersEdit.component';
import { CustomersDetailsComponent } from './CustomersDetails.component';

const CustomersRoutes: Routes = [
	{ path: 'Customers',  component: CustomersListComponent },
	{ path: 'Customers/add', component: CustomersAddComponent },
	{ path: 'Customers/:id', component: CustomersEditComponent },
	{ path: 'Customers/Details/:id', component: CustomersDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CustomersRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CustomersRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/Customers-routing.module.ts